import { createContext, useContext } from 'react';
import { addTupleObject, setTuplesObject, ApiConfigService, setBaseUrlString } from '../core';
import { type ApiConfigProviderProps } from './types/propTypes';

const ApiConfigContext = createContext<{
  baseUrl: string;
  tuples: Record<string, string>;
}>({
  baseUrl: '',
  tuples: {},
});

const ApiConfigProvider = ({ baseUrl, tuples, children }: ApiConfigProviderProps) => {
  setBaseUrlString(baseUrl);
  ApiConfigService.setTuples(tuples);
  return (
    <ApiConfigContext.Provider
      value={{
        baseUrl,
        tuples,
      }}
    >
      {children}
    </ApiConfigContext.Provider>
  );
};

const useBaseUrl = () => {
  const { baseUrl } = useContext(ApiConfigContext);
  return baseUrl;
};

const useTuples = () => {
  const { tuples } = useContext(ApiConfigContext);
  return tuples;
};

const useAddTuple = (key: string, value: string) => {
  addTupleObject(key, value);
};

const useSetTuples = (tupleObject: { [key: string]: string }) => {
  setTuplesObject(tupleObject);
};

export default ApiConfigProvider;
export { useBaseUrl, useTuples, useAddTuple, useSetTuples };
export type { ApiConfigProviderProps };
